module.exports = __webpack_public_path__ + "assets/img/11f6-ao.svg";